const fileExtensionRe = /^(.*?)\.([^.]+)$/;
const suffixes = {
  large: "lg",
  medium: "md",
  small: "sm",
  xlarge: "xl",
};

/**
 * Accepts a base asset source and a list of breakpoints with a media query and a source. The
 * suffix is added to the file name of the asset. So for example /asset/hero.jpg becomes
 * /asset/hero-sm.jpg for the small breakpoint with a suffix of "sm".
 * @param {string} source The base source string of the asset
 * @param {object[]} breakpoints An array of breakpoints including a media query and a suffix that
 *  should be attached to the source file name at the given media query.
 * @returns An array of objects with media queries and sources
 */
export const createSourceBreakpoints = (source, breakpoints) => {
  const [path, searchParams] = source.split("?");
  const [, filePath, fileExtension] = path.split(fileExtensionRe);

  return breakpoints.map(({ query, size }) => {
    const suffix = suffixes[size];
    let src = `${filePath}-${suffix}.${fileExtension}`;

    if (searchParams) {
      src = `${src}?${searchParams}`;
    }

    return { query, src };
  });
};
